import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { MessageEntity } from './message-entities';

@inject(IHttpClient)
export class MessagesApi extends ApiBase {

    private readonly _baseUrl: string = 'api/messages';

    constructor(http: IHttpClient) {
        super(http);
    }

    public async send(dto: MessageEntity): Promise<ApiResponse> {
        const response = await this.post(this._baseUrl, dto);
        return response.content;
    }

}
